<template>
    <div class="certificate-list-content">
        <div class="top">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="genera-breadcrumb">
                <el-breadcrumb-item>评价中心</el-breadcrumb-item>
                <el-breadcrumb-item>证书管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{type == 1?"已获得证书":"未获得证书"}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="btn-back">
                <el-button type="primary" @click="backBtn()">返回</el-button>
            </div>
        </div>
        <div class="search-content">
            <el-input v-model="searchCertificateValue"
                      placeholder="请输入搜索内容"
                      slot="prepend"
                      class="w300-input"
                      @keyup.enter.native="certificateSearch">
                <el-button slot="append" icon="el-icon-search" @click="certificateSearch"></el-button>
            </el-input>
        </div>
        <el-table :data="studentListTable" style="width: 100%; flex: 1" height="1%" size="medium"
                  :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#eee',fontSize: '16px',height:'60px'}"
                  class="customTable" :cell-style="{fontSize: '16px',color: '#333',height: '70px'}">
            <el-table-column prop="nickname" label="学生名称"></el-table-column>
            <el-table-column prop="certificate_name" label="证书名称" v-if="type == 1"></el-table-column>
            <el-table-column prop="exam_name" label="考试名称"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <div class="link-list" v-if="type == 1">
                        <el-link type="success" :underline="false"
                                 @click="editCertificate(scope.row)">编辑
                        </el-link>
                        <el-link type="primary" :underline="false" @click="viewCertificate(scope.row)">查看</el-link>
                        <el-link type="danger" :underline="false" @click="delCertificate(scope.row)">删除</el-link>
                    </div>
                    <div class="link-list" v-else>
                        <el-link type="success" :underline="false" @click="generateCertificate(scope.row)">生成证书
                        </el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="pages-center"
                :current-page="studentPages.currentPageNum"
                :page-size="studentPages.eachPageNum"
                layout="prev, pager, next, jumper"
                :total="studentPages.total"
                @current-change="studentCurrentChange">
        </el-pagination>
        <div style="position: fixed;top: -10000px; left: -10000px;">
            <ViewCertificateModule :obj="certificateForm" id="ViewCertificateModule" ref="ViewCertificateModule"/>
        </div>
    </div>
</template>

<script>
    import ViewCertificateModule from '../../../components/teacher/certificateContent/ViewCertificateModule.vue'
    import {
        checkCenter_alreadyGetCertificateList,
        delCertificate,
        studentCertificate,
        checkCenter_notGetCertificateList
    } from '@/utils/apis'
    import htmlToPdf from "@/utils/htmlToPdf.js";

    export default {
        name: "certificateDetail",
        components: {
            ViewCertificateModule,
        },
        data() {
            return {
                examId: this.$route.query.exam_id || null,//考试id
                examName: this.$route.query.exam_name || null,//考试名称
                certificate_id: this.$route.query.id || null,//证书id
                searchCertificateValue: '',//搜索证书
                studentListTable: [],
                certificateForm: {},
                //分页
                studentPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0
                },
                role: '',//角色id
                selectArr: [],
                type: this.$route.query.type || null,
            }
        },
        mounted() {
            if (this.type == 1) {
                this.getStudentCertificateList()
            } else {
                this.getNOStudentCertificateList()
            }
        },
        created() {
            this.role = localStorage.getItem('role');
        },
        methods: {
            // 获取学生获得证书列表
            getStudentCertificateList() {
                let params = {
                    paging: 1,
                    pageSize: this.studentPages.eachPageNum,
                    page: this.studentPages.currentPageNum,
                    check_center_exam_id: this.examId
                }
                if (this.searchCertificateValue) {
                    params.keyword = this.searchCertificateValue
                }
                checkCenter_alreadyGetCertificateList(params).then((res) => {
                    this.studentListTable = res.data.list ? res.data.list : []
                    this.studentPages.total = res.data.total;
                }).catch((err) => {
                    console.log(err);
                });
            },// 获取未获得证书列表
            getNOStudentCertificateList() {
                let params = {
                    paging: 1,
                    pageSize: this.studentPages.eachPageNum,
                    page: this.studentPages.currentPageNum,
                    check_center_exam_id: this.examId,
                }
                if (this.searchCertificateValue) {
                    params.keyword = this.searchCertificateValue
                }
                checkCenter_notGetCertificateList(params).then((res) => {
                    this.studentListTable = res.data.list ? res.data.list : []
                    this.studentPages.total = res.data.total;
                }).catch((err) => {
                    console.log(err);
                });
            },

            //搜索事件
            certificateSearch() {
                if (this.type == 1) {
                    this.getStudentCertificateList()
                } else {
                    this.getNOStudentCertificateList()
                }
            },
            viewCertificate(row) {
                let routeDate = this.$router.resolve({
                    path: '/certificateManage/viewCertification',
                    query: {
                        id: row.certificate_id,
                        exam_id: this.examId,
                        exam_name: row.exam_name,
                        type: this.type
                    }
                })
                window.open(routeDate.href, '_blank')
            },
            // 编辑证书
            editCertificate(row) {
                let routeDate = this.$router.resolve({
                    path: '/certificateManage/generateCertification',
                    query: {
                        certificate_id: row.certificate_id,
                        exam_id: this.examId,
                        exam_name: row.exam_name,
                        student_id: row.student_id,
                        id_num: row.id_num,
                        type: 1
                    }
                })
                window.open(routeDate.href, '_blank')
            },
            // 返回
            backBtn() {
                this.$router.push({
                    path: '/certificateManage/Index'
                })
            },
            selectChange(selection) {
                this.selectArr = selection
            },
            //删除证书
            delCertificate(row) {
                this.$confirm('是否删除', '提示消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'green-message-box',
                    type: 'warning'
                }).then(() => {
                    let param = {
                        id: row.certificate_id
                    }
                    delCertificate(param).then((res) => {
                        this.$message.success(res.msg);
                        if (this.type == 1) {
                            this.getStudentCertificateList()
                        } else {
                            this.getNOStudentCertificateList()
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            },
            //生成证书
            generateCertificate(row) {
                let routeDate = this.$router.resolve({
                    path: '/certificateManage/generateCertification',
                    query: {
                        exam_id: this.examId,
                        student_id: row.student_id,
                        // no_student_id:this.studentId,
                        // exam_name:this.examName,
                        nickname: row.nickname,
                        id_num: row.id_num,
                        type: 2
                    }
                })
                window.open(routeDate.href, '_blank')
            },
            //切换分页
            studentCurrentChange(val) {
                this.studentPages.currentPageNum = val;
                if (this.type == 1) {
                    this.getStudentCertificateList()
                } else {
                    this.getNOStudentCertificateList()
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .certificate-list-content {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0 20px;

        .top {
            margin: 20px 0;
            position: relative;

            .btn-back {
                position: absolute;
                top: -12px;
                right: 20px;
            }
        }

        .search-content {
            margin-bottom: 20px;
        }

        ::v-deep .el-table th > .cell {
            padding-right: 0;
        }

        ::v-deep .el-table-column--selection .cell {
            padding-right: 0;
        }
    }
</style>